<template>
  <div>
    <section class="orderSect">
      <!--S 检索-->
      <el-form inline :model="formInline">
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input v-model="formInline.orderno" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="formInline.cardholdertel" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
         <el-form-item label="">
          <!-- S 订单状态下拉组件 -->
          <OrderState :excludeStates="excludeOrderStates" @orderStatusObtain="orderStatusReceive"></OrderState>
          <!-- E 订单状态下拉组件 -->
        </el-form-item>
        <el-form-item label="达达订单状态">
          <!-- S 订单状态下拉组件 -->
         <el-select v-model="formInline.ddorderstate" placeholder="请选择" clearable>
          <el-option
            v-for="item in ddoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
          <!-- E 订单状态下拉组件 -->
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="formInline.submitdate"
            type="daterange"
            range-separater="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="formInline.orderDateOptions"
            :unlink-panels="true"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="订单内容">
          <el-input v-model="formInline.ordercontent" placeholder="请输入订单内容" clearable></el-input>
        </el-form-item>
        <!--<el-form-item label="发货方" v-if="ElementControls('zdzp') == '0'">
            <el-select v-model="formInline.handlercode" filterable clearable placeholder="请选择或输入" :filter-method="filterFlow" @focus="closeFlowName">
              <div class="optionBox" :class="{'showPage':flowList.length<=30}">
                <el-option
                  v-for="item in flowList"
                  :key="item.flowcode"
                  :label="item.flowname"
                  :value="item.flowcode">
                </el-option>
              </div>
              <el-pagination
                @current-change="flowCurrentChange" :hide-on-single-page="true"
                :current-page="flowCurrent"
                :page-sizes="[30]"
                :page-size="30"
                layout="pager"
                :total="flowBean.totalnum" v-show="flowBean.totalnum"
                small>
              </el-pagination>
            </el-select>
          </el-form-item>-->
          <el-form-item v-if="Number(ElementControls('intracity_delivery'))==1">
            <el-checkbox v-model="formInline.yysm" @change="search()">同城上门</el-checkbox>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">查询</el-button>
        </el-form-item>
        <el-form-item>
            <el-button type="primary"  plain   @click="expout" >导出</el-button>
        </el-form-item>
        <em class="simpleSearch" @click="highShow = !highShow">{{highShow?'精简筛选':'高级筛选'}}</em>
        <div v-show="highShow">
          <el-form-item label="收货/提货人">
            <el-input v-model="formInline.receivername" placeholder="请输入收货/提货人" clearable></el-input>
          </el-form-item>
          <el-form-item label="省/市">
            <el-input v-model="formInline.provinceorcity" placeholder="请输入省/市" clearable></el-input>
          </el-form-item>
          <el-form-item label="预售品牌">
            <!-- 预售品牌下拉组件 S -->
            <PresaleBrandSelect @brandObtain="brandReceive"></PresaleBrandSelect>
            <!-- 预售品牌下拉组件 E -->
          </el-form-item>
          <!-- 配送方下拉组件 S -->
          <DeliveryAreaSelect @deliveryObtain="deliveryReceive"></DeliveryAreaSelect>
          <!-- 配送方下拉组件 E -->
          <!-- S 终端类型下拉组件 -->
          <TerminalType @terminalTypeObtain="terminalTypeReceive"></TerminalType>
          <!-- E 终端类型下拉组件 -->
        </div>
      </el-form>
      <!--E 检索-->
      <!--S 全部订单列表-->
    <div class="allOrderTab individualiz">
      <el-table
        :data="allOrderData"
        v-loading="loading"
        ref="orderTable"
        class="orderTable comTable"
        border
        :maxHeight="tableHeight"
      >
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column label="订单号" prop="orderno" sortable fixed min-width="230">
          <template slot-scope="scope">
            <p class="textFl haveChildOd">
              {{scope.row.orderno}}
            </p>
            <small
              class="textFl"
              :title="scope.row.submitdate | dateFormate"
            >{{scope.row.submitdate | dateFormate}}</small>
          </template>
        </el-table-column>
        <el-table-column v-if="orderStyle !==1"  label="订单状态" prop="ordstate" sortable min-width="240">
          <template slot-scope="scope">
            <strong>
              <span
                :class="scope.row.ordstate | orderStateColorClass"
              >{{scope.row.ordstate | ddorderStateFilter(scope.row.ddorderstate)}}</span>&nbsp;/&nbsp;
              <i  class="blackColor"
              >{{scope.row.ordstate === 0 ||scope.row.ordstate === 8? '配送费待支付' : '配送费已支付'}}</i>
            </strong>
          </template>
        </el-table-column>
        <el-table-column v-if="orderStyle !==1"  label="达达订单状态" prop="ddorderstate" sortable min-width="180">
          <template slot-scope="scope">
            <strong>
              <span
                :class="scope.row.ddorderstate | orderDaDaColorClass"
              >{{scope.row.ddorderstate | statusDadaFilter}}</span>
            </strong>
          </template>
        </el-table-column>
        <el-table-column label="订单内容" prop="ordercontent" sortable min-width="380">
          <template slot-scope="scope">
            <section class="pdr30">
              <div
                class="greyColor textFl"
                :title="scope.row.ordercontent"
              >{{scope.row.ordercontent}}</div>
              <p class="orderContentI">
                <el-tag :type="scope.row.makeinvstate==0?'info':(scope.row.makeinvstate==1?'warning':'primary')" plain v-if="pubordprintinfo&&pubordprintinfo.bsupinvoice==1&&ElementControls('jinshizun')!=1">
                  {{scope.row.makeinvstate | makeinvstateFilter}}
                </el-tag>
                <em class="priceFont">
                  <em>￥</em>
                  {{scope.row.allamount | formatAmount}}
                </em>
                <!-- 订单类型 -->
                <i
                  :class="{'iconth':scope.row.ordertype===0,'iconsc': scope.row.ordertype===1,'iconbf':scope.row.ordertype===2,'iconfresh':scope.row.ordertype===3,'iconmd':scope.row.ordertype===5}"
                  :title="scope.row.ordertype | orderTypeFilter"
                ></i>

                <!-- 商品类型 -->
                <i
                  :class="{'iconsw':scope.row.goodstype===0,'iconcard': scope.row.goodstype===1,'icone-card':scope.row.goodstype===2}"
                  :title="scope.row.goodstype | goodsTypeFilter"
                ></i>

                <!-- 终端类型 -->
                <i
                  :class="{'iconpc':scope.row.terminaltype===0,'iconiPhone': scope.row.terminaltype===1,'iconwx':scope.row.terminaltype===2}"
                  :title="scope.row.terminaltype | terminalTypeFilter"
                ></i>
              </p>
            </section>
          </template>
        </el-table-column>
        <el-table-column  label="订单来源" min-width="220">
          <template slot-scope="scope">
            <p
              class="textFl"
              :title="scope.row.orderuname"
            >
            <el-tag
              type="danger"
              plain
              :title="scope.row.prosource | prosourceFilter"
            >{{scope.row.prosource | prosourceFilter}}</el-tag>
            {{scope.row.orderuname||'--'}}</p>
            <!-- <small
              v-if="scope.row.odSourceAddr"
              :title="scope.row.odSourceAddr"
              class="textFl"
            >{{scope.row.odSourceAddr}}</small> -->
            <small v-show="scope.row.channelname"
              class="textFl"
              :title="'销售渠道：'+ scope.row.channelname"
            >销售渠道：{{scope.row.channelname?scope.row.channelname:'--'}}</small>
          </template>
        </el-table-column>
        <el-table-column label="发货方" :min-width="orderStyle !==1?180:240">
          <template slot-scope="scope">
            <p
              class="textFl"
              :title="scope.row.handlercode === '0' ? '总部' : scope.row.handlername"
            >{{scope.row.handlercode === '0' ? '总部' : scope.row.handlername}}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" min-width="400">
          <template slot-scope="scope">
            <section class="pdr30">
              <div class="shouMsg">
                <strong v-if="scope.row.dataorigin==55&&Number(ElementControls('intracity_delivery'))==1" class="blueColor">同城上门</strong>
                <strong v-else 
                  class="orangeColor"
                >同城配送</strong>
                <span class="textFl">{{scope.row.receivername}}</span>
                <em>{{scope.row.receivertel}}</em>
              </div>
              <p
                class="greyColor textFl"
                :title="scope.row | delimodeAddressFilter(pubordprintinfo)"
              >{{scope.row | delimodeAddressFilter(pubordprintinfo)}}</p>
            </section>
          </template>
        </el-table-column>
        <!--<el-table-column   label="订单备注" min-width="150">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.ordermemo">{{scope.row.ordermemo | empty}}</p>
          </template>
        </el-table-column>-->
        <el-table-column label="买家备注" min-width="150">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.buyermemo">{{scope.row.buyermemo | empty}}</p>
          </template>
        </el-table-column>
        <!--<el-table-column label="卖家备注" min-width="150">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.sellermemo">{{scope.row.sellermemo | empty}}</p>
          </template>
        </el-table-column>-->
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-dropdown trigger="click" @command="handleCommand" placement="bottom-start">
              <span class="el-dropdown-link">
                全部操作
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <template v-if="scope.row.dataorigin==55">
                  <el-dropdown-item :command="{type:'orderDetail',data:scope.row}">详情</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ordstate==1" :command="{type:'qxorder',data:scope.row}">取消订单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ordstate==1" :command="{type:'zengchang',data:scope.row}">正常结单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ordstate==1" :command="{type:'yichang',data:scope.row}">异常结单</el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item :command="{type:'orderDetail',data:scope.row}">详情</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ordstate==0" :command="{type:'qxorder',data:scope.row}">取消订单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ordstate==1&&(scope.row.ddorderstate==''||scope.row.ddorderstate==null)" :command="{type:'preOrder',data:scope.row}">同城配送下单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ordstate==3&&(scope.row.ddorderstate==5||scope.row.ddorderstate==10)" :command="{type:'resendOrder',data:scope.row}">订单重发</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ddorderstate==1 || scope.row.ddorderstate==2|| scope.row.ddorderstate==100" :command="{type:'cancelLocalOrder',data:scope.row}">取消下单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ddorderstate==9" :command="{type:'errorEndOrder',data:scope.row}">妥投异常收货</el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData">
            <span>暂无数据</span>
          </div>
        </template>
      </el-table>
    </div>
    <!--E 全部订单列表-->

    <!-- S 分页 -->
    <Page
      :pageTotal="page.pagetotal"
      :currentPage="page.currentpage"
      :pageSize="page.pagesize"
      v-on:nowPageParam="nowPageParam"
    ></Page>
    <!-- S 分页 -->

    <!--S 订单详情组件-->
    <OrderDetail
      v-if="currentItem"
      :dadatype="1"
      :orderno="currentItem.orderno"
      :orderDetailBox="orderDetailShow"
      @closeODBox="orderDetailShow = false"
    ></OrderDetail>
    <!--E 订单详情组件组件-->

    <!-- S 同城配送下单弹窗-->
    <el-dialog :visible.sync="preOrderShow" class="comDlog intraCityOrderDlg" append-to-body :close-on-click-modal="false">
      <div slot="title" class="dialog-title">同城配送下单</div>
      <div  v-loading="repreOrder" element-loading-text="预下单中...">
        <el-row class="flexBet">
          <el-col :span="10">
            <p class="commonTit"><b>门店信息</b></p>
            <dl class="flexUI" v-if="flowInfo">
              <dt><img class="imgCenter" :src="flowInfo.mainpiclink?flowInfo.mainpiclink:'https://presale.jhtsoft.com/picms/c47499b67d489.png'" onerror="this.src='https://presale.jhtsoft.com/picms/c47499b67d489.png'" alt=""></dt>
              <dd class="storeWrap">
                <h4>{{flowInfo.flowname}}</h4>
                <p class="flexUI" v-if="flowInfo.linkman"><i class="iconuser"></i>{{flowInfo.linkman}}&nbsp;&nbsp;{{flowInfo.mobile}}&nbsp;&nbsp;{{flowInfo.tel}}</p>
                <p class="flexUI" v-else><i class="iconuser"></i>{{flowInfo.linkman}}&nbsp;&nbsp;{{flowInfo.mobile}}&nbsp;&nbsp;{{flowInfo.tel}}</p>
                <p class="flexUI"><i class="icondw"></i>{{flowInfo.province}} {{flowInfo.city}} {{flowInfo.district}} {{flowInfo.addrdet}}</p>
              </dd>
            </dl>
          </el-col>
          <el-col :span="4" class="feeWrap">
            <p class="icontransfert"></p>
            <template>
              <span class="priceFont redColor"><i>￥</i>{{prePlace.deliverFee |formatAmount}}</span>
              <small>配送费</small>
            </template>
          </el-col>
          <el-col :span="10">
            <p class="commonTit"><b>收货信息</b></p>
            <div class="manWrap" v-if="currentItem">
              <h4>{{currentItem.receivername}}&nbsp;&nbsp;{{currentItem.receivertel?currentItem.receivertel:currentItem.cardholdertel}}</h4>
              <p><em>收货地址：</em><span>{{currentItem.fulladdr}}</span></p>
              <p v-if="currentItem.buyermemo"><em>买家备注：</em><span>{{currentItem.buyermemo}}</span></p>
            </div>
          </el-col>
        </el-row>
        <p class="commonTit"><b>订单内容</b></p>
        <el-table :data="orderGoodsinfoList" class="comTable" border maxHeight="280">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column label="商品内容" min-width="350">
            <template slot-scope="scope">
              <section class="flexUI">
                <div class="zoneInfo">
                  <p class="textHiden" :title="scope.row.goodsname">{{scope.row.goodsname}}</p>
                  <p class="textHiden" :title="scope.row.kindinfo">{{scope.row.kindinfo}}</p>
                </div>
              </section>
            </template>
          </el-table-column>
          <el-table-column label="价格(￥)" min-width="180">
            <template slot-scope="scope">
              <span class="priceFont">
                {{scope.row.goodsmallprice  |formatAmount}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="数量" min-width="100">
            <template slot-scope="scope">
              <span>{{scope.row.num}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <span v-if="preordertime!=180" class="timeNum"><b class="redColor">{{preordertime}}s</b>后预下单失效，可重新预下单</span>
        <el-button v-else type="primary"  plain @click="closeLocalOrderBox(0)" :loading="cxloading">重新预下单</el-button>
        <el-button :type="prePlace?'primary':'info'" :disabled="prePlace?false:true"  :loading="fbloading" @click="closeLocalOrderBox(1)">发布</el-button>
      </div>
    </el-dialog>
    <!-- E 同城配送下单弹窗-->
    <!--S 提交成功提示框-->
    <el-dialog class="comDlog alertMsgDlog" title="系统提示" :visible.sync="distributionAmountShow" append-to-body :close-on-click-modal="false">
      <div class="alertBox">
        <i class="el-icon-success"></i>
        <h2 class="comAlert">下单成功！等待接单...</h2>
        <p>达达订单号：<em class="orangeColor" v-if="this.currentItem">{{this.currentItem.orderno}}</em></p>
      </div>
      <p class="msgBtns">
        <el-button type="primary" size="small" @click="getDaDaOrder">关闭</el-button>
      </p>
    </el-dialog>
    <!-- E 提交成功提示框 -->


    <!--S 同城配送订单取消原因弹窗-->
    <el-dialog class="comDlog pushDlog" title="选择取消原因" :visible.sync="cancelOrderTipShow" append-to-body :close-on-click-modal="false">
      <dl class="reasonRule">
        <dt class="iconbulb">订单取消需按规则收取一定的违约金，望知悉以下<b class="fwBold">"费用扣除说明"</b>！</dt>
        <dd>1、接单<em>1分钟</em>以内取消不扣违约金；<br>
            2、接单后<em>1~15分钟</em>内取消订单，运费退回。同时扣除<em>2元</em>作为给配送员的违约金；<br>
            3、配送员接单后<em>15分钟</em>未到店，商户取消不扣违约金。
        </dd>
      </dl>
      <ul class="reasonUl">
        <li :class="{'on':item.id == curReasonID}" v-for="(item,index) in cancelReasonList" :key="index" @click="curReasonID = item.id;showError = false">{{item.reason}}</li>
        <li class="iptLi" :class="{'errorLine':cancelReason=='' && showError}" v-show="curReasonID == 10000">
          <el-input type="textarea" v-model.trim="cancelReason" :autosize="{ minRows: 5, maxRows: 10}" maxlength="20" show-word-limit placeholder="请输入取消原因" @blur="iptChange"></el-input>
          <span class="redColor" v-show="cancelReason=='' && showError">当取消原因为其他时，此处必填</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="yyloading" @click="confirmPush(1)">确定</el-button>
        <el-button @click="confirmPush(0)">取消</el-button>
      </span>
    </el-dialog>
    <!--E 同城配送订单取消原因弹窗-->
    <el-dialog class="comDlog recoverDlog" title="提示" :visible.sync="recoverDialogVisible" :close-on-click-modal="false" append-to-body>
        <p>确定要进行取消订单吗？</p>
        <el-input type="textarea" v-model.trim="recoverMemo"  maxlength="100" placeholder='请输入内容'></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary"  :loading="showbutton"  @click="getCoverSuccessShow(true)">确定</el-button>
            <el-button   @click="getCoverSuccessShow(false)">取消</el-button>
        </span>
    </el-dialog>
    <!--S 提交成功提示框-->
    <el-dialog class="comDlog alertMsgDlog" title="系统提示" :visible.sync="cancelLocalOdBoxShow" append-to-body :close-on-click-modal="false">
      <div class="alertBox">
        <i class="el-icon-success"></i>
        <h2 class="comAlert">订单已取消！</h2>
        <p>当前订单需承担违约金：<span class="priceFont"><i>￥</i>{{deduct_fee | formatAmount}}</span></p>
      </div>
      <p class="msgBtns">
        <el-button type="primary" size="small" @click="cancelLocalOdBoxShow = false">关闭</el-button>
      </p>
    </el-dialog>
    <!-- E 提交成功提示框 -->

    </section>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from "@/apis/api.js";
export default {
  name: "IntraCityDistributionOrder",
  data() {
    return {
      ddoptions: [{
          value: '1',
          label: '待接单'
        }, {
          value: '2',
          label: '待取货'
        }, {
          value: '3',
          label: '配送中'
        }, {
          value: '4',
          label: '已完成'
        }, {
          value: '5',
          label: '已取消'
        }, {
          value: '8',
          label: '指派单'
        }, {
          value: '9',
          label: '妥投异常之物品返回中'
        }, {
          value: '10',
          label: '妥投异常之物品返回完成'
        }, {
          value: '100',
          label: '骑士到店'
        }, {
          value: '1000',
          label: '创建达达运单失败'
        }],
      excludeOrderStates: [],
      pubordprintinfo: null,
      pubconfiginfo: null,
      // 地图配送，0：否；1：开启
      sppsfw: 0,
      // 是否展示高级筛选
      highShow: false,
      orderStyle: 0,
      // 检索
      formInline: {
        // 发货方
        handlercode: '',
        ordstate:null,
        // 达达订单状态
        ddorderstate: null,
        // 派单状态
        desstate: null,
        // 拆单状态
        seporderstate: null,
        // 订单类型
        ordertype: null,
        // 商品类型
        goodstype: null,
        // 终端类型
        terminaltype: null,
        // 下单时间
        submitdate: [],
        // 期望发货日期
        recvdate: [],
        // 提货时间thstarttime
        thtime: [],
        // 订单号
        orderno: "",
        // 订单内容
        ordercontent: "",
        // 手机号
        cardholdertel: "",
        // 收货人/提货人
        receivername: "",
        // 省/市
        provinceorcity: "",
        // 预售品牌
        brandcode: "",
        // 配送方
        regioncode: "",
        // 全天、中午、晚上时间段选择
        apm: null,
        orderDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
        makeinvstate: null, // 开票状态
        isddorder:1,
        yysm:false,//同城上门订单
      },
      searchParam: null,
      flowList: [], // 发货方列表
      queryFlowname: '', // 检索的流向名称
      flowCurrent: 1, // 请求的商品的页面
      flowBean: { // 返回的商品分页信息
        totalnum: 0,
      },
      expcode:'',
      firstShow: true, //初始是否显示提示语
      iscancel: false,
      currentItem: '',
      pubordprintinfo: null,
      innerSearchParam: {},
      loading: false,
      childPopperShow: false,
      page: {
        pagetotal: 0,
        pagesize: 30,
        currentpage: 1,
        isnewcomp: 1,
        sortparam: null,
        sorttype: 0
      },
      // 订单来源列表
      sourceLists: [
        { label: "总部", value: 0, checked: false },
        { label: "门店", value: 1, checked: false },
        { label: "消费者", value: 2, checked: false },
        { label: "仓分享合作", value: 4, checked: false },
        { label: "外部对接", value: 3, checked: false }
      ],
      // 送货方式列表
      deliveryModeLists: [
        { label: "自提", value: 0, checked: false },
        { label: "送货", value: 1, checked: false }
      ],
      // 批量操作 0:派单；1:订单配货
      batchOperate: -1,
      // 发货方弹窗
      shipperShow: false,
      allOrderData: [],
      sendOrder: false,
      // 表格动态高度
      tableHeight: window.innerHeight * 0.8,
      // 订单详情
      orderDetailShow: false,
      // 修改订单弹窗
      editOrderShow: false,
      editOdBtnVal: "",
      // 默认备注操作
      cancelEdit: "cancel",
      // 取消订单备注弹窗
      orderMemo: false,
      // 取消订单备注按钮关闭还是确定
      btnVal: "",
      // 修改金额弹窗
      orderAmountShow: false,
      // 高级修改弹窗
      seniorShow: false,
      seniorForm: {
        // 高级修改表单
        orderStatus: "",
        memo: ""
      },
      // 需要派单的订单列表
      dispatchOrder: [],
      allChecked: false,
      selectedDatas: [],
      isapm: false,
      rowIndex: -1, // 操作的订单下标
      //--------同城配送订单---------
      preOrderShow:false,//预下单弹窗
      preordertime:180,//预下单失效时间3min
      repreOrder:false,//重新预下单
      distributionAmountShow:false,//同城配送运费显示
      flowInfo:'',
      orderGoodsinfoList:[],//订单内容
      cancelOrderTipShow:false,//取消订单确认提示
      cancelLocalOdBoxShow:false,//选择取消订单的原因
      cancelReasonList:[],//取消订单原因
      curReasonID:'',//当前原因
      showError:false,//失焦为空
      cancelReason:'',//其他原因说明
      prePlace:'',
      teill:null,
      fbloading:false,
      cxloading:false,
      yyloading:false,
      deliveryNo:'',
      deduct_fee:'',
      recoverDialogVisible:false,
      recoverMemo:'',
      showbutton:false,
    };
  },
  components: {
    // 配送方下拉组件
    DeliveryAreaSelect: resolve =>
      require(["@/components/common/DeliveryAreaSelect.vue"], resolve),
    // 预售品牌下拉组件
    PresaleBrandSelect: resolve =>
      require(["@/components/common/PresaleBrandSelect.vue"], resolve),
    // 订单状态下拉组件
    OrderState: resolve =>
      require(["@/components/Gadget/OrderState.vue"], resolve),
    // 拆单状态下拉组件
    SplitState: resolve =>
      require(["@/components/Gadget/SplitState.vue"], resolve),
    // 派单状态下拉组件
    DispatchState: resolve =>
      require(["@/components/Gadget/DispatchState.vue"], resolve),
    // 订单类型下拉组件
    OrderType: resolve =>
      require(["@/components/Gadget/OrderType.vue"], resolve),
    // 商品类型下拉组件
    GoodsType: resolve =>
      require(["@/components/Gadget/GoodsType.vue"], resolve),
    // 终端类型下拉组件
    TerminalType: resolve =>
      require(["@/components/Gadget/TerminalType.vue"], resolve),
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    // 查看订单详情
    OrderDetail: resolve =>
      require(["@/components/common/OrderDetail.vue"], resolve),
  },
  methods: {
    getCoverSuccessShow(val){
      if(val){
        if(this.recoverMemo==''){
           this.$message.error('请输入取消原因!')
           return
        }
          this.showbutton=true;
           Api.CANCELORDER({orderno:this.currentItem.orderno,memo:this.recoverMemo}).then(res =>{
            if(res.data.status=="200"){
                    this.recoverDialogVisible=false;
                    this.search();
                    Message({
                      type:'success',
                      message:res.data.message
                    })
            }else{
                Message({
                  type:'error',
                  message:res.data.message
                })
            }
            this.showbutton=false;
            this.recoverMemo='';
          })
      }else{
      this.recoverDialogVisible=false;
      this.recoverMemo='';
      this.showbutton=false;
      }
    },
    jiedan(type){
      if(type==0){
            MessageBox.confirm(`确定要结单吗？`, '确认提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          Api.FINISHECARDORDER({type:type,orderno:this.currentItem.orderno}).then(res =>{
            if(res.data.status=="200"){
                    this.search();
                    Message({
                      type:'success',
                      message:res.data.message
                    })
            }else{
                Message({
                  type:'error',
                  message:res.data.message
                })
            }
          })

        }).catch(() => {
        });
      }else{
              this.$prompt('请输入异常结单备注', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  showInput:true,
                  inputPlaceholder:'请输入内容',
                  inputType:'textarea',
                  inputValidator(value){
                    if(value==undefined){
                     return '备注不能为空'
                    }else if(value==''){
                      return '备注不能为空'
                    }else if(value.length>100){
                         return '备注不能超过100'
                    }
                  },
                  inputErrorMessage: '备注不能为空'
                }).then(({ value }) => {
                    Api.FINISHECARDORDER({type:type,orderno:this.currentItem.orderno,memo:value}).then(res =>{
                      if(res.data.status=="200"){
                              this.search();
                              Message({
                                type:'success',
                                message:res.data.message
                              })
                      }else{
                          Message({
                            type:'error',
                            message:res.data.message
                          })
                      }
                    })
                }).catch(() => {      
                });
      }
       
    },
    //操作指令
    handleCommand(event) {
      this.currentItem = event.data;
      let command = event.type;
      switch (command) {
        case 'zengchang':
        this.jiedan(0);
        break;
        case 'yichang':
        this.jiedan(1);
        break;
        case 'orderDetail':
        this.orderDetailShow = true;
        break;
        case 'qxorder':
        this.recoverDialogVisible = true;
        break;
        case 'preOrder':
        this.preOrderShow = true;
        //预下单成功后开始倒计时
        Api.GET_FLOWDETAIL({flowcode:this.currentItem.handlercode}).then(res =>{
           if(res.data.status=="200"&&res.data.data){
              this.flowInfo = res.data.data
           }
        })
        Api.GETORDERGOODSSALEDET({orderno:this.currentItem.orderno}).then(res =>{
           if(res.data.status=="200"&&res.data.data){
              this.orderGoodsinfoList = res.data.data
           }
        })
        this.test(0);
        break;
        case 'resendOrder':
         MessageBox.confirm(`确定要重发订单【${this.currentItem.orderno}】吗？`, '确认提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          Api.REPLACEORDER({orderno:this.currentItem.orderno}).then(res =>{
            if(res.data.status=="200"){
                    this.search();
                    Message({
                      type:'success',
                      message:res.data.message
                    })
            }else{
                Message({
                  type:'error',
                  message:res.data.message
                })
            }
          })

        }).catch(() => {
        });
        break;
        case 'cancelLocalOrder':
          this.curReasonID ='';
          this.cancelReason = '';
          this.cancelOrderTipShow = true;
        break;
         case 'errorEndOrder':
          MessageBox.confirm('当前订单妥投异常，确定商品已返回？', '确认提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
           Api.CONFIRMGOODS({orderno:this.currentItem.orderno}).then(res =>{
            if(res.data.status=="200"){
                    this.search();
                    Message({
                      type:'success',
                      message:res.data.message
                    })
            }else{
                Message({
                  type:'error',
                  message:res.data.message
                })
            }
          })
          }).catch(() => {

          });
        break;
      }
    },
    //同城配送费用
    closeLocalOrderBox(val){
      if(val==1){
        this.fbloading = true;
        Api.AFTERPLACEORDER({orderno:this.currentItem.orderno}).then(res =>{
           if(res.data.status=="200"){
             this.fbloading = false;
             this.preOrderShow = false;
             this.distributionAmountShow = true;
             this.search();
           }else{
              this.fbloading = false;
             this.$message.error(res.data.message)
           }
        }).catch((err)=>{
           this.fbloading = false;
        })
      }else{
        this.test(1);
      }
    },
    test(index){
        if(index==1){
           this.cxloading = true;
        }
        this.repreOrder = true;
        this.preordertime = 180;
        clearInterval(this.teill);
        Api.PREPLACEORDER({orderno:this.currentItem.orderno}).then(res =>{
           if(res.data.status=="200"&&res.data.data){
                     this.cxloading = false;
                     this.teill = setInterval(() => {
                      this.preordertime--;
                      if(this.preordertime==0){
                        this.preordertime = 180;
                        clearInterval(this.teill);
                      }
                    }, 1000)
              this.repreOrder = false;
              this.prePlace = res.data.data
           }else{
              this.$message.error(res.data.message)
              this.cxloading = false;
              this.repreOrder = false;
           }
        }).catch((err)=>{
            this.cxloading = false;
            this.repreOrder = false;
        })
    },
    //生成达达订单
    getDaDaOrder(){
      this.distributionAmountShow = false;
    },
    //取消原因为空
    iptChange(){
      if(this.cancelReason == ''){
        this.showError = true
      }
    },
    //确定取消同城配送订单
    confirmPush(val){
      if(val==1){
        this.yyloading = true;
        let param ={
          orderno:this.currentItem.orderno,
          cancel_reason_id:this.curReasonID,
          cancel_reason:this.cancelReason,
        }
        if(!this.curReasonID){
          this.$message.error('请选择取消原因！')
          this.yyloading = false;
          return
        }
        if(this.curReasonID==10000&&this.cancelReason==''){
          this.$message.error('请输入取消原因说明！')
          this.yyloading = false;
          return
        }
        Api.FORMALCANCEL(param).then(res =>{
           if(res.data.status=="200"){
              this.search();
              this.deduct_fee = res.data.data.deduct_fee;
              this.cancelOrderTipShow = false;
              this.cancelLocalOdBoxShow = true;
           }else{
             this.$message.error(res.data.message)
           }
           this.yyloading = false;
        }).catch((err)=>{
            this.yyloading = false;
        })

      }else{
        this.cancelOrderTipShow = false;
      }
    },
    // 获取流向方列表
    getFlowList(size) {
      let flowParams = {
        objtype: '0,1',
        flowname: this.queryFlowname,
        pageparam: {
          pagesize: size?size:30, //每页条数
          currentpage: this.flowCurrent, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      Api.GET_FLOWLIST(flowParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.flowList = res.data.data;
            let info = {
              flowname: '总部',
              flowcode: '0',
            }
            if(this.flowCurrent == 1 && (this.queryFlowname==='' || (info.flowname.indexOf(this.queryFlowname)!=-1))) {
              this.flowList.unshift(info);
            }
          } else {
            this.flowList = [];
          }
          this.flowBean = res.data.pagebean;
        }
      })
    },
    // 规格分页
    flowCurrentChange(val) {
      this.flowCurrent = val;
      this.getFlowList();
    },
    // 搜索规格方法
    filterFlow(item) {
      this.queryFlowname = item;
      this.flowCurrent = 1;
      this.getFlowList();
    },
    // 清除筛选的名称
    closeFlowName() {
      this.queryFlowname = '';
      this.flowCurrent = 1;
      this.getFlowList();
    },
    // 订单状态下拉选择值
    orderStatusReceive(value) {
      this.formInline.ordstate = value;
    },
    // 终端类型下拉选择值
    terminalTypeReceive(value) {
      this.formInline.terminaltype = value;
    },
    // 配送方下拉选择值
    deliveryReceive(value) {
      this.formInline.regioncode = value;
    },
    // 预售品牌下拉选择值
    brandReceive(value) {
      this.formInline.brandcode = value;
    },
    // 检索
    search: function(isexportout) {
      let param = {};
      param.gtype = this.orderStyle;
      Object.assign(param, this.formInline);
      delete param.submitdate;
      delete param.recvdate;
      delete param.thtime;

      if (this.formInline.submitdate && this.formInline.submitdate.length > 0) {
        param.startsubmitdate = this.dateTime(this.formInline.submitdate[0]);
        param.endsubmitdate = this.dateTime(this.formInline.submitdate[1]);
      }

      if (this.formInline.recvdate && this.formInline.recvdate.length > 0) {
        param.startRecvdate = this.formInline.recvdate[0];
        param.endRecvdate = this.formInline.recvdate[1];
      }

      if (this.formInline.thtime && this.formInline.thtime.length > 0) {
        param.thstarttime = this.formInline.thtime[0];
        param.thendtime = this.formInline.thtime[1];
      }
      if (isexportout === 1) {
        param.isexport = true;
        param.exceltype = 0;
      }

      delete param.orderDateOptions;
      param.yysm = this.formInline.yysm?1:'';//同城上门订单
      this.searchParam = param;
      this.getOrderBaseInfoList();
    },
        // 导出
    expout: function() {
      this.loading = true;
      let param = {};
      param.gtype = this.orderStyle;
      Object.assign(param, this.formInline);
      delete param.submitdate;
      delete param.recvdate;
      delete param.thtime;

      if (this.formInline.submitdate && this.formInline.submitdate.length > 0) {
        param.startsubmitdate = this.dateTime(this.formInline.submitdate[0]);
        param.endsubmitdate = this.dateTime(this.formInline.submitdate[1]);
      }

      if (this.formInline.recvdate && this.formInline.recvdate.length > 0) {
        param.startRecvdate = this.formInline.recvdate[0];
        param.endRecvdate = this.formInline.recvdate[1];
      }

      if (this.formInline.thtime && this.formInline.thtime.length > 0) {
        param.thstarttime = this.formInline.thtime[0];
        param.thendtime = this.formInline.thtime[1];
      }
        param.isexport = true;
        param.exceltype = 0;
      delete param.orderDateOptions;
      param.yysm = this.formInline.yysm?1:'';//同城上门订单
      this.searchParam = param;
      Api.GETINTRACITYSERVICEORDERWXPORTURL(param).then(res => {
        console.log(res.data);
        if (res.data.status === "200") {
          window.location.href = res.data.data;
        }
        this.loading = false;
      });
    },
    // 获取订单信息列表
    getOrderBaseInfoList: function() {
      this.loading = true;
      let page = this.page;
      let param = {
        pageparam: {
          pagesize: page.pagesize,
          currentpage: page.currentpage,
          isnewcomp: page.isnewcomp,
          sortparam: page.sortparam,
          sorttype: page.sorttype
        }
      };
      Object.assign(param, this.searchParam);
      Api.GETINTRACITYSERVICEORDERBASELIST(param).then(res => {
        this.toTableTop("orderTable");
        if (res.data.status === "200") {
          let datas = res.data.data;
          this.allOrderData = datas;
          this.page.pagetotal = res.data.pagebean.totalnum;
        } else {
          Message.error({ message: res.data.message });
        }
        this.loading = false;
      });
    },
    nowPageParam: function(pageSize, currentPage) {
      this.page.currentpage = currentPage;
      this.page.pagesize = pageSize;
      this.getOrderBaseInfoList();
    },
        // 动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.orderTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },
    getCancelReasonList(){
      Api.GETCANCEREASONLIST({}).then(res =>{
        if(res.data.status=="200"){
          this.cancelReasonList = res.data.data;
        }
      })
    }

  },
  created() {
    // 页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
    // 订单服务配置
    this.pubordprintinfo = this.config.getPubordprintinfo();
    // 公共服务配置
    let pubconfiginfo = this.config.getPubconfiginfo();
    this.pubconfiginfo = pubconfiginfo;
    // 是否开通地图配送0：否；1：是
    let sppsfwValue = this.ElementControls("sppsfw");
    this.sppsfw = sppsfwValue && sppsfwValue == 1 ? 1 : 0;
    this.isapm = sppsfwValue && sppsfwValue == 1;
  },
  filters: {
    // 订单状态颜色区分
    orderDaDaColorClass: function(value) {
      return {
        greenColor: value === 100 ,
        orangeColor: value === 0 || value === 1 || value === 2 || value === 3 || value === 8,
        greyColor: value === 5,
        blueColor: value === 4,
        redColor: value === 9 || value === 10 || value === 1000
      };
    },
    // 订单状态颜色区分
    orderStateColorClass: function(value) {
      return {
        greenColor: value >= 3 && value <= 5,
        orangeColor: value <= 1,
        greyColor: value === 7 || value === 8,
        blueColor: value === 6
      };
    },
    // 提货地址
    delimodeAddressFilter(row,info) {
        return row.fulladdr;
    },
    // 开票状态
    makeinvstateFilter(val) {
      if(val == 0) {
        return '无需开票';
      } else if(val == 1) {
        return '待开票';
      } else if(val == 2) {
        return '开票完成';
      }
    }
  },
  mounted() {
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
    this.formInline.submitdate = [start, '']
    this.search();
    setTimeout(() => {
      this.getHeight();
    }, 200);
    // this.getOrderBaseInfoList();
  },
  destroyed(){
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  },
  watch:{
    cancelOrderTipShow(val){
      if(val){
          this.getCancelReasonList();
      }
    },
    highShow(val){
      if(val){
          let tbHeight = this.$refs.orderTable.$el.offsetTop; //顶部检索条件占据的高度
          this.tableHeight = window.innerHeight - tbHeight - 190;
      }else{
          this.getHeight()
      }

    }
  }
};
</script>

<style scoped>
@import "Css/Style.css";

/*高级修改弹窗*/
.seniorMdg >>> .el-dialog {
  width: 500px;
}
.seniorMdg >>> .el-form-item__content {
  width: 65%;
  min-width: 200px;
  max-width: 340px;
}
.seniorMdg >>> .el-form-item__content .el-select {
  width: 100%;
}

/*同城配送订单弹窗 start*/
.intraCityOrderDlg >>> .el-dialog {width:1400px;height:650px;}
.intraCityOrderDlg >>> .dialog-title small {margin-left:30px;font-size: 12px; color:#999;}
.intraCityOrderDlg .timeNum {position: absolute; left:20px; font-size: 12px;}
.intraCityOrderDlg .timeNum b {font-weight: 600; padding-right:5px;}
.intraCityOrderDlg >>> .el-icon-loading:before {color: var(--main-color);font-size: 14px;}
.intraCityOrderDlg .el-row.flexBet{align-items: flex-start!important; }
.feeWrap {text-align: center;margin:0 30px;}
.feeWrap .icontransfert {font-size: 60px; color: var(--main-color);}
.feeWrap span {display:block; font-size: 18px;}
.intraCityOrderDlg .commonTit {margin-bottom:20px;}
.intraCityOrderDlg dl { padding-bottom:20px;margin:0 auto;}
.intraCityOrderDlg dt {position:relative;width:100px; height:100px;margin-right:10px;border:solid 1px #ebeefe;}
.intraCityOrderDlg .storeWrap {flex:1;max-width: calc(100% - 132px);}
.storeWrap h4,.manWrap h4 {font-weight: 600;padding-bottom:10px;}
.storeWrap {line-height:25px;}
.storeWrap p i{font-size: 16px; padding-right:5px;}
.manWrap p {display:-webkit-flex; display:flex;line-height: 20px; font-size: 13px; }
.manWrap p em {color:#999; width:70px;white-space: nowrap;}
.manWrap p span{flex:0 0 calc(100% - 70px);}
/*运费确认提示框 */
.alertMsgDlog >>> .el-dialog {width:420px;border-radius:4px;overflow: hidden;padding-bottom:20px;}
.alertBox {position:relative;width:70%;margin:0 auto; padding:17px 10px 17px 36px;}
.alertBox .el-icon-success{position:absolute; left:0; top:18px;color:#67C23A;font-size: 24px;}
.alertMsgDlog .msgBtns {text-align: center;padding:5px 15px 0;}
.alertMsgDlog small {color:#999;font-size: 12px;padding:10px 0;}
.alertMsgDlog small b {font-weight: 600; padding:0 5px;}
/*同城配送订单弹窗 end*/

/*同城配送订单取消原因 start*/
.pushDlog >>> .el-dialog {width:1000px;height: 770px;}
.pushDlog >>> .el-dialog__body {max-height:667px!important;padding:10px 40px!important;}
.reasonRule {padding-bottom:20px;border-bottom:solid 1px #ebeefe;color:#333;}
.reasonRule dt {padding:10px 0;font-size: 14px;line-height:20px;}
.reasonRule dt .fwBold {font-weight: 600;color:#333;}
.reasonRule dd {padding-left:25px;font-size: 12px; line-height:20px;}
.reasonRule dd em {padding:0 5px;color:#FF7018;}
.reasonUl {display:-webkit-flex;display:flex;-webkit-align-items: flex-start; align-items: flex-start;-webkit-justify-content:space-between;justify-content:space-between;flex-wrap: wrap;margin:15px 30px;}
.reasonUl li {position:relative;flex:0 0 calc(50% - 40px); white-space: nowrap; text-align: center; line-height: 50px; border:solid 1px #ebeefe;margin:10px 0;border-radius:6px; cursor: pointer;}
.reasonUl li.on {border: solid 2px var(--main-color); line-height: 48px;}
.reasonUl li.on:after {content: "\e637"; position: absolute; right: -3px; bottom: -3px; font-family: "iconfont" !important;font-size: 24px; line-height: 24px; color: var(--main-color);}
.reasonUl .iptLi {border:none;}
.reasonUl .iptLi >>> .el-textarea__inner {border-color:#ebeefe!important;}
.reasonUl .errorLine >>> .el-textarea__inner {border-color:#FA2F2F!important;}
.iptLi:before {content: "*"; position: absolute; left:-15px; top:-5px; color:#FA2F2F }
.iptLi span {position: absolute;bottom:-22px;left:0; font-size: 12px;color:#FA2F2F;line-height:20px;}
/*同城配送订单取消原因 end*/
.recoverDlog>>>.el-dialog{
    width: 420px;
}
.recoverDlog>>>.el-dialog__footer{
    box-shadow: none;
    margin-bottom: 5px;
}
.recoverDlog>>>.el-button{
    padding: 8px 15px;
}
.recoverDlog p{
    color: #666;
    line-height: 25px;
}
.recoverDlog>>>.el-dialog__body{
    padding: 13px 20px 11px 20px;
}
.recoverDlog>>>.el-textarea{
    margin-top: 15px;
}
</style>





// WEBPACK FOOTER //
// src/views/OrderFolder/IntraCityDistributionOrder.vue